import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import { Logo } from 'components/logos/logo';
import styles from './layout.module.scss';

export const Layout = ({ children }: { children?: React.ReactNode }) => (
  <Box
    component="main"
    className={styles.layout_container}
  >
    <Logo width={450} />
    <Box className={styles.page_content}>
      {children ?? <Outlet />}
    </Box>
  </Box>
);
